var locale = {
  placeholder: '請選擇時間'
};
export default locale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/time-picker/locale/zh_TW.js
// module id = ./node_modules/antd/es/time-picker/locale/zh_TW.js
// module chunks = 0